import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Main } from './main'

const rootElement = document.getElementById('jsSearchPanel');
const rootElementData = rootElement?.dataset

if (rootElement && rootElementData) {
  const root = createRoot(rootElement)
  root.render(
    <Main />
  )
} else {
  console.warn('コンテンツ表示用の要素が存在しません')
}